module.exports = __webpack_public_path__ + "img/drivebuzz_Bee_artemis_4c.927f7ca3.svg";